// extracted by mini-css-extract-plugin
export var divider = "_sg-0";
export var systemMessage = "_sg-1";